import React, { PropTypes } from 'react';
import Translator from 'bazinga-translator';

import {moveButton, deleteButton, editButton} from '../../svgs.jsx';

const DraftOptions = (props)=> {

    const handleEditClick = (e)=>{
        e.preventDefault();
        props.onEditClick()
    };

    const handleMoveClick = (e)=>{
        e.preventDefault();
        props.onMoveClick();
    };

    const handleDeleteClick = (e)=>{
        e.preventDefault();
        props.onDeleteClick();
    };

    return (
    <div className="box-drafts__options">
        <p>{Translator.trans('drafts.options.header', [], 'app')}</p>
        <a href="#" title={Translator.trans('drafts.options.edit', [], 'app')} onClick={handleEditClick}>{editButton()}<p>{Translator.trans('drafts.options.edit', [], 'app')}</p></a>
        <a href="#" title={Translator.trans('drafts.options.move', [], 'app')} onClick={handleMoveClick}>{moveButton()}<p>{Translator.trans('drafts.options.move', [], 'app')}</p></a>
        <a href="#" title={Translator.trans('drafts.options.delete', [], 'app')} onClick={handleDeleteClick}>{deleteButton()}<p>{Translator.trans('drafts.options.delete', [], 'app')}</p></a>
    </div>
    )
};

DraftOptions.propTypes = {
    onEditClick: PropTypes.func.isRequired,
    onMoveClick: PropTypes.func.isRequired,
    onDeleteClick: PropTypes.func.isRequired
};

export default DraftOptions;


// WEBPACK FOOTER //
// ./src/_app/drafts/components/Draft/DraftOptions.jsx